export const config = {
  rowSelection: false,
  columns: [
    {
      title: '品牌名称',
      dataIndex: 'name',
      width: 200,
      ellipsis: true,
    },
    {
      title: '英文名',
      dataIndex: 'code',
      width: 200,
      ellipsis: true,
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      width: 200,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 160,
      itemType: 'dateTime',
    },
    {
      title: '状态',
      dataIndex: 'enabled',
      width: 90,
      fixed: 'right',
      render: 'switchRender',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 120,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'nameKey',
      label: '品牌名称',
    },
    {
      label: '状态',
      name: 'enabled',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        {label: '启用', value: true},
        {label: '禁用', value: false},
      ],
    },
  ],
  footer: [
    {
      label: '添加品牌',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
